// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3dEL4","buttons":"PendingPaymentAlert_buttons__3uQpi"};